var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_226_9619)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.454,
    cy: 267.501,
    r: 107.501,
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 263.452,
    cy: 275.942,
    rx: 52.3429,
    ry: 52.9057,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 234.748,
    cy: 262.434,
    r: 21.3874,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.363 185.89L316.921 207.84L323.112 222.473",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.31 188.141L265.165 211.056",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.974 238.863L349.423 247.857M349.423 247.857L330.312 245.637M349.423 247.857L339.997 275.942",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.926 323.22L346.188 333.351",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.188 298.506L366.139 303.906",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.204 190.393L208.587 205.31V223.037",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.66 238.864L177.21 247.857M177.21 247.857L203.793 244.424M177.21 247.857L180.717 270.314",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.33 318.717L177.068 328.848",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.32 292.878L159.369 298.278",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.635 332.06C381.146 329.864 423.051 388.965 430.064 418.79L100 418.79C128.272 355.115 177.585 332.06 269.635 332.06Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.064 418.79C423.051 388.965 381.146 329.864 269.635 332.06C177.585 332.06 128.272 355.115 100 418.79",
    stroke: "#1C1B1F",
    strokeWidth: 20,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.494 198.73C148.982 200.926 107.078 141.825 100.064 112H430.128C401.856 175.675 352.544 198.73 260.494 198.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.064 112C107.078 141.825 148.982 200.926 260.494 198.73C352.544 198.73 401.856 175.675 430.128 112",
    stroke: "#1C1B1F",
    strokeWidth: 20,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -0.374557,
    cy: 525.941,
    rx: 141.448,
    ry: 77.9406,
    fill: "#1C1B1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_226_9619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/안과_안구건조증.a34085adc47513beed8ae20d3364728f.svg";
export { ForwardRef as ReactComponent };